import { render, staticRenderFns } from "./limitBuyCoupon.vue?vue&type=template&id=0db11782&scoped=true&"
import script from "./limitBuyCoupon.vue?vue&type=script&lang=ts&"
export * from "./limitBuyCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./limitBuyCoupon.vue?vue&type=style&index=0&id=0db11782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db11782",
  null
  
)

export default component.exports